var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 115,
    height: 115,
    viewBox: "0 0 115 115",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_x31_87-js",
    transform: "translate(0.463)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25",
    "data-name": "Group 25",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6",
    "data-name": "Rectangle 6",
    width: 115,
    height: 115,
    transform: "translate(-0.463 0)",
    fill: "#f0db4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M179.238,274.115c0,11.2-6.575,16.308-16.154,16.308-8.654,0-13.662-4.468-16.231-9.887l8.809-5.316c1.7,3,3.236,5.547,6.96,5.547,3.544,0,5.8-1.387,5.8-6.805V237.21h10.812v36.9Z",
    transform: "translate(-116.626 -184.437)",
    fill: "#323330"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M319.542,288.575c-10.042,0-16.539-4.777-19.7-11.043l8.809-5.085c2.311,3.776,5.342,6.575,10.658,6.575,4.469,0,7.344-2.234,7.344-5.341,0-3.7-2.927-5.008-7.884-7.191l-2.7-1.156c-7.807-3.313-12.969-7.5-12.969-16.308,0-8.116,6.189-14.279,15.819-14.279,6.883,0,11.814,2.388,15.358,8.655l-8.424,5.393c-1.849-3.313-3.852-4.622-6.96-4.622-3.159,0-5.162,2-5.162,4.622,0,3.236,2,4.546,6.652,6.574l2.7,1.156c9.194,3.929,14.356,7.962,14.356,17,0,9.707-7.653,15.049-17.9,15.049Z",
    transform: "translate(-231.351 -182.59)",
    fill: "#323330"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJs);
export default __webpack_public_path__ + "static/media/js.1ef0c0c3e1a3de32fef877ffc2976dbc.svg";
export { ForwardRef as ReactComponent };